import csharp from '../Section/Images/projectDetails/csharp.png'
import mark from '../Section/Images/projectDetails/mark.png'
import meta from '../Section/Images/projectDetails/meta.png'
import openai from '../Section/Images/projectDetails/openai.png'
import photon from '../Section/Images/projectDetails/photon.png'
import photoshop from '../Section/Images/projectDetails/photoshop.png'
import unity from '../Section/Images/projectDetails/unitys.png'
import blender from '../Section/Images/Skills/blender.png'

// Videos
import fall3D from '../Section/Images/videos/fall3D.mp4'


// afrofusion
import afro1 from '../Section/Images/projectDetails/afrofusion/afro1.png'
import afro2 from '../Section/Images/projectDetails/afrofusion/afro2.png'
import afro3 from '../Section/Images/projectDetails/afrofusion/afro3.png'
import afro4 from '../Section/Images/projectDetails/afrofusion/afro4.png'
import afro5 from '../Section/Images/projectDetails/afrofusion/afro5.png'
import afro6 from '../Section/Images/projectDetails/afrofusion/afro6.png'

// utopia
import utopia1 from '../Section/Images/projectDetails/utopia/utopia1.png'
import utopia2 from '../Section/Images/projectDetails/utopia/utopia2.png'
import utopia3 from '../Section/Images/projectDetails/utopia/utopia3.png'
import utopia4 from '../Section/Images/projectDetails/utopia/utopia4.png'
import utopia5 from '../Section/Images/projectDetails/utopia/utopia5.png'

// morbus
import morbus1 from '../Section/Images/projectDetails/morbus/morbus1.png'
import morbus2 from '../Section/Images/projectDetails/morbus/morbus2.png'
import morbus3 from '../Section/Images/projectDetails/morbus/morbus3.png'
import morbus4 from '../Section/Images/projectDetails/morbus/morbus4.png'
import morbus5 from '../Section/Images/projectDetails/morbus/morbus5.png'
import morbus6 from '../Section/Images/projectDetails/morbus/morbus6.png'

// golf
import golf1 from '../Section/Images/projectDetails/golf/golf1.png'
import golf2 from '../Section/Images/projectDetails/golf/golf2.png'
import golf3 from '../Section/Images/projectDetails/golf/golf3.png'
import golf4 from '../Section/Images/projectDetails/golf/golf4.png'
import golf5 from '../Section/Images/projectDetails/golf/golf5.png'
import golf6 from '../Section/Images/projectDetails/golf/golf6.png'

// vrcar
import vrcar1 from '../Section/Images/projectDetails/car/car1.png'
import vrcar2 from '../Section/Images/projectDetails/car/car2.png'
import vrcar3 from '../Section/Images/projectDetails/car/car3.png'
import vrcar4 from '../Section/Images/projectDetails/car/car4.png'
import vrcar5 from '../Section/Images/projectDetails/car/car5.png'
import vrcar6 from '../Section/Images/projectDetails/car/car6.png'

//draw
import draw1 from '../Section/Images/projectDetails/draw/draw1.png'
import draw2 from '../Section/Images/projectDetails/draw/draw2.png'
import draw3 from '../Section/Images/projectDetails/draw/draw3.png'
import draw4 from '../Section/Images/projectDetails/draw/draw4.png'
import draw5 from '../Section/Images/projectDetails/draw/draw5.png'
import draw6 from '../Section/Images/projectDetails/draw/draw6.png'

// super
import super1 from '../Section/Images/projectDetails/Super/Super1.png'
import super2 from '../Section/Images/projectDetails/Super/Super2.png'
import super3 from '../Section/Images/projectDetails/Super/Super3.png'
import super4 from '../Section/Images/projectDetails/Super/Super4.png'
import super5 from '../Section/Images/projectDetails/Super/Super5.png'
import super6 from '../Section/Images/projectDetails/Super/Super6.png'

// fruit
import fruit1 from '../Section/Images/projectDetails/Fruit/Fruit1.png'
import fruit2 from '../Section/Images/projectDetails/Fruit/Fruit2.png'
import fruit3 from '../Section/Images/projectDetails/Fruit/Fruit3.png'
import fruit4 from '../Section/Images/projectDetails/Fruit/Fruit4.png'
import fruit5 from '../Section/Images/projectDetails/Fruit/Fruit5.png'
import fruit6 from '../Section/Images/projectDetails/Fruit/Fruit6.png'

//fall
import fall1 from '../Section/Images/projectDetails/Fall/Fall1.png'
import fall2 from '../Section/Images/projectDetails/Fall/Fall2.png'
import fall3 from '../Section/Images/projectDetails/Fall/Fall3.png'
import fall4 from '../Section/Images/projectDetails/Fall/Fall4.png'
import fall5 from '../Section/Images/projectDetails/Fall/Fall5.png'
import fall6 from '../Section/Images/projectDetails/Fall/Fall6.png'

// space
import space1 from '../Section/Images/projectDetails/Space/space1.png'
import space2 from '../Section/Images/projectDetails/Space/space2.png'
import space3 from '../Section/Images/projectDetails/Space/space3.png'
import space4 from '../Section/Images/projectDetails/Space/space4.png'
import space5 from '../Section/Images/projectDetails/Space/space5.png'
import space6 from '../Section/Images/projectDetails/Space/space6.png'

//candy
import candy1 from '../Section/Images/projectDetails/Candy/candy1.png'
import candy2 from '../Section/Images/projectDetails/Candy/candy2.png'
import candy3 from '../Section/Images/projectDetails/Candy/candy3.png'
import candy4 from '../Section/Images/projectDetails/Candy/candy4.png'


export const projectDetails = [
    // id 1
    {
        id: 1,
        projectName: "Afrofusion Multiplayer",
        projectLink: "https://www.youtube.com/watch?v=yP3xr9SlV4c",
        video: "https://www.youtube.com/embed/yP3xr9SlV4c?si=5vJ8ilQ35nRM0OHB",
        description: {
            desc1: "This is a multiplayer experience where users get to Meet up Discuss,join rooms and select avatars at will, its a project built to encourage socialization and it can also serve an educational, industrial and therapeutic purpose.",
            desc2: "The aim of this project is to facilitate a VR environment that is not limited by distance an environment where people can find solace and healthy interaction.",
            desc3: "The study of 3d sound and also creating a sound that imitates thr real deal",
            desc4: "Researched on how to use the new photon upgraded scripts and also a way to balance it with the new unity input manager.Creating a system where all users can meander the environment with ease without having motion sickness",
            desc5: "After reiterating so many designs and model I finally decided to create a calm experience that can be used educationally and also therapeutically",
            desc6: "Had to also conclude on how the ownership Game-objects would be passed around in the scene from player to player."
        },
        projectTools: {
            img1: photon,
            img2: csharp,
            img3: unity,
            img4: photoshop
        },
        designImg: {
            img1: afro1,
            img2: afro2,
            img3: afro3,
            img4: afro4,
            img5: afro5,
            img6: afro6
        }
    },
    // id 2
    {
        id: 2,
        projectName: "Utopia VR",
        projectLink: "",
        video: "https://www.youtube.com/embed/1H9GAbxIeUQ?si=cf45ZOQGitBOJnP5",
        description: {
            desc1: " This is a Project Powered by Open AI artificial intelligence(AI).Set in a distant future the users take the character of AGENT MOORE and they have to discuss with Doctor TITI(AI powered NPC) to understand their mission and defeat the evil warlord OVAL REAPER.",
            desc2: "The aim of this project is to show how artificial intelligence can actually be used to improve the scope of gaming and Virtual reality experience . to show the innovative prowess of artificial intelligence.",
            desc3: "The limited documentation of open AI and how integrate it required me study harder and also curate other ways to execute this project.",
            desc4: "I had to source on ways to use Meta Voice to recreate the voice to text and also text to voice. and also ways to convert the words to strings and also for it to be received as an input.",
            desc5: "Finally Created a project that had fully implemented OpenAI API and MetaVoice SDK with a user Model that functioned fully with Inverse Kinematic Rig.",
            desc6: "Also had to add additional interaction for the shooting range to give users something to have fun with."
        },
        projectTools: {
            img1: openai,
            img2: csharp,
            img3: unity,
            img4: meta
        },
        designImg: {
            img1: utopia1,
            img2: utopia2,
            img3: utopia3,
            img4: utopia4,
            img5: utopia5
        }
    },
    // id 3
    {
        id: 3,
        projectName: "Morbus VR",
        projectLink: "",
        video: "https://www.youtube.com/embed/97zkoWpJtkw?si=sl2TTGAD9N9S5rkD",
        description: {
            desc1: "This is was created to be the Medical Encyclopedia for Virtual reality, Powered bt the mixed reality toolkit(MRTK3) provided by Microsoft Mixed reality team. its purpose is to aid users understand medicine through VR.",
            desc2: "The aim of this project is to build a virtual space where users can enjoy learning and also see things they really had no visual comprehension in their reality thereby unlocking a new reading method.",
            desc3: "Mrtk3 had to be used and i had to fully confirm that it would suffice for this project .",
            desc4: "Also i had to study hard to come up diseases and ailments and also a way to present them in Virtual Reality in a way it wont overwhelm the users. .",
            desc5: "After sessions of study and experiments i decided on what to develop and how to fully create it .",
            desc6: "After testing with several users and also checking the FPS level i decided it was good to go."
        },
        projectTools: {
            img1: blender,
            img2: csharp,
            img3: unity,
            img4: mark,
            img5: photoshop
        },
        designImg: {
            img1: morbus1,
            img2: morbus2,
            img3: morbus3,
            img4: morbus4,
            img5: morbus5,
            img6: morbus6
        }
    },
    //id 4
    {
        id: 4,
        projectName: "GolfVR",
        projectLink: "",
        video: "https://www.youtube.com/embed/uzdsosDQc08?si=Gw6_nzXx9lLVxxcF",
        description: {
            desc1: "This is a Virtual Golf arena where you get to play Golf at different locations on a floating island and also teleport with portals .",
            desc2: "A project created solely to stimulate the users imaginations, and also act as a virtual relaxation spot. from a calming sound of the wind in your ears, to the chirping of birds to the intoxicating view while playing Golf, its an all round tingle to your inner imaginations.",
            desc3: "visualizing an island that floats in the clouds, and creating the sound engineering fot that environment alone, required a whole new level of dedication.",
            desc4: "I had to study collisions and velocity applications for different angles and speed of contacts.",
            desc5: "The process of designing and finally getting to see it work in real time was awesome. Had a lot to take home and i also got to experience a new feeling of new knowledge during the developmental process",
            desc6: "After testing with several users and also checking the FPS level i decided it was good to go."
        },
        projectTools: {
            img1: blender,
            img2: csharp,
            img3: unity,
            img4: photoshop
        },
        designImg: {
            img1: golf1,
            img2: golf2,
            img3: golf3,
            img4: golf4,
            img5: golf5,
            img6: golf6
        }
    },
    //id 5
    {
        id: 5,
        projectName: "VR car",
        projectLink: "",
        video: "https://www.youtube.com/embed/dZaNqyCsxD4?si=Cv4gvwIgjG6bgXF9",
        description: {
            desc1: "This is a virtual experience for Car lovers, a space where you get to drive, without caution.",
            desc2: "I created this project as a guy who has never driven a car, a guy who wants others to see how they ride cars through my eyes. a fully functioning car without gears or brakes..lol A car for the Unskilled Riders.",
            desc3: "I had to do a whole research on how cars operate, increase in distance and MPH over time, why it increases, how it increases and how i can also slow it down.",
            desc4: "I also wanted it to be my way, since i wanted users to be able to see how cars work through the eys of those that have never driven a car.",
            desc5: "Developing was relatively easier than expected, and for once i was quick with development. i also had enough time to add some features i liked into the project.",
            desc6: "It was a project that was generally embraced after development. users had a hard time driving because it was their first time in my head...lol"
        },
        projectTools: {
            img1: blender,
            img2: csharp,
            img3: unity,
            img4: photoshop
        },
        designImg: {
            img1: vrcar1,
            img2: vrcar2,
            img3: vrcar3,
            img4: vrcar4,
            img5: vrcar5,
            img6: vrcar6
        }
    },
    //id 6
    {
        id: 6,
        projectName: "Draw VR",
        projectLink: "",
        video: "https://www.youtube.com/embed/D4wKl3CySL8?si=5iluGjRKvJ72yFk4",
        description: {
            desc1: "This is an artistic virtual experience for art lovers, where you get do draw in any style you want..",
            desc2: "I created this project with the love of art in mind, its a project meant to bring out the coolness and calmness of art through virtual reality. a space where tech and art meet to satisfy you.",
            desc3: "I had to learn to create shaders, mirror them, and most times invert them to provide a perfect image of the users intent.",
            desc4: "i also had to think of what environment and sound could really boost the mental creativity of users.",
            desc5: "I enjoyed developing this, as a developer with a strong background in design this was more of me having fun than me creating an experience. The shaders were the only Big issue.",
            desc6: "Scripting for this project was easy, it didn’t require a heavy amount of scripting."
        },
        projectTools: {
            img1: blender,
            img2: csharp,
            img3: unity,
            img4: photoshop
        },
        designImg: {
            img1: draw1,
            img2: draw2,
            img3: draw3,
            img4: draw4,
            img5: draw5,
            img6: draw6
        }
    },
    //id 7
    {
        id: 7,
        projectName: "Superblaze VR",
        projectLink: "",
        video: "https://www.youtube.com/embed/HesBzUp1id0?si=Miz8xvNMPCnhwLXH",
        description: {
            desc1: "This was my attempt at recreating all the experiences of S uperHot VR.. AND IT WAS AWESOME.",
            desc2: "I created this project to be a lookalike to SuperHot VR, And this was created solely to test my skills and capabilities.",
            desc3: "I had to to really SuperHot VR multiple times just to realize where i would start getting inspirations from.",
            desc4: "i also had to study to how to manipulate and Npc velocity in relation to body Movement .",
            desc5: "I enjoyed developing this, as a developer with a strong background in design this was more of me having fun than me creating an experience. The shaders were the only Big issue.",
            desc6: "Scripting for this project was easy, it didn’t require a heavy amount of scripting."
        },
        projectTools: {
            img1: blender,
            img2: csharp,
            img3: unity,
            img4: photoshop,
        },
        designImg: {
            img1: super1,
            img2: super2,
            img3: super3,
            img4: super4,
            img5: super5,
            img6: super6
        }
    },
    // id 8
    {
        id: 8,
        projectName: "FruitNinja VR",
        projectLink: "",
        video: "https://www.youtube.com/embed/PQzxW-pHPZ8?si=374kQHcIoWVeUJT3",
        description: {
            desc1: "This project is the replica of Fruit Ninja mobile, but for lovers of Virtual reality, you get to cut fruits, in a jungle and you also get to avoid a grenade.",
            desc2: "I created this project to spark a feeling of nostalgia in the mind of users and also remind them that we can always relive our childhood experience no matter our AGE ..",
            desc3: "I had to search for clips of fruit ninja because to be sincere i hardly remember what is looked like anymore.",
            desc4: "i also tried my best to incorporate a ninja vibe by adding a Japanese Katana to the scene..",
            desc5: "Developing the interaction for this Game was more of a path discovery for me. it dawned on me how simple looking but how difficult the mechanism for most games are.",
            desc6: "And also it required more scripting than expected ."
        },
        projectTools: {
            img1: blender,
            img2: csharp,
            img3: unity,
            img4: photoshop
        },
        designImg: {
            img1: fruit1,
            img2: fruit2,
            img3: fruit3,
            img4: fruit4,
            img5: fruit5,
            img6: fruit6
        }
    },
    // id 9
    {
        id: 9,
        projectName: "Fall3D",
        projectLink: "",
        video: fall3D,
        description: {
            desc1: "This is a 3D ball movement game and it only need the swiping as an interaction, the goal of the game is for users to prevent the ball from falling.",
            desc2: "This is just a fun game meant to test the reaction speed of the users .",
            desc3: "This game is built on the foundation of unpredictability, so i had to learn more about randomness .",
            desc4: "i also tried to make sure the users understand the motive from the get go.",
            desc5: "Developing this game was quite fun since i literally had to build everything i used from the unity inspector..",
            desc6: "this also required more scripting than expected ."
        },
        projectTools: {
            img1: blender,
            img2: csharp,
            img3: unity,
            img4: photoshop
        },
        designImg: {
            img1: fall1,
            img2: fall2,
            img3: fall3,
            img4: fall4,
            img5: fall5,
            img6: fall6
        }
    },
    //id 10
    {
        id: 10,
        projectName: "SpaceRover",
        projectLink: "",
        video: "https://www.youtube.com/embed/SptsXpHaHdw?si=DAl8kOW4doky1PGC",
        description: {
            desc1: "This is a space project where Users get to explore the vastness of space and also interact with their surrounding, from shooting meteors to journeying the solar system.",
            desc2: "This is just a fun game meant to make users feel freedom like they never had .",
            desc3: "This game had me checking out our solar system . and also methods to make interaction realistic",
            desc4: "",
            desc5: "The development process was modest and good..",
            desc6: ""
        },
        projectTools: {
            img1: blender,
            img2: csharp,
            img3: unity
        },
        designImg: {
            img1: space1,
            img2: space2,
            img3: space3,
            img4: space4,
            img5: space5,
            img6: space6
        }
    },
    // id 11
    {
        id: 11,
        projectName: "CandyPatch",
        projectLink: "",
        video: "https://www.youtube.com/embed/I4U3VkDTYgA?si=zPzbXOq30nocOthz",
        description: {
            desc1: "This is a fun 2D games meant for relaxation, made with color popping objects. have fun catching the candies.",
            desc2: "This is game is aimed at kids , in a world of over stimulating experiences, this should be able to balance it out.",
            desc3: "Had to really see what people find basic and less stimulating",
            desc4: "",
            desc5: "it was fun developing for 2d.. easy as expected",
            desc6: ""
        },
        projectTools: {
            img1: csharp,
            img2: unity
        },
        designImg: {
            img1: candy1,
            img2: candy2,
            img3: candy3,
            img4: candy4
        }
    }
]
